"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const styles_1 = require("@mui/material/styles");
const DateTimeFilterActions = (props) => {
    const { cancelText, applyText, onCancel, onApply } = (0, styles_1.useThemeProps)({ props, name: "DateTimeFilterActions" });
    return (react_1.default.createElement(Box_1.default, { sx: { display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 } },
        react_1.default.createElement(Button_1.default, { variant: "text", onClick: (e) => onCancel(e) }, cancelText),
        react_1.default.createElement(Button_1.default, { variant: "text", sx: { ml: 2 }, onClick: (e) => onApply(e) }, applyText)));
};
exports.default = DateTimeFilterActions;
